import React, { useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Form from 'react-bootstrap/Form';
import estante from '../../assets/Estante.svg';
import buscar from '../../assets/Buscar.svg';
import lembrete from '../../assets/Lembrete.svg';
import perfil from '../../assets/Perfil.svg';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import Load from '../../components/load/load';
import {Context} from '../../context/AuthContext';
import './menu.style.css';
import { ModalElement } from '../modal/modalElement';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import _ from 'lodash'

const Menu = () => {
    const [searchModalShow, setSearchModalShow] = React.useState(false);
    const [validated, setValidated] = React.useState(true);
    const [search, setSearch] = React.useState("");
    const [bookData, setBookData] = React.useState([]);
    const [createNewBookModal, setCreateNewBookModal] = React.useState(false);
    const [title, setTitle] = React.useState('');
    const [author, setAuthor] = React.useState('');
    const [publisher, setPublisher] = React.useState('');
    const [pages, setPages] = React.useState(0);
    const [description, setDescription] = React.useState('');
    const [image, setImage] = React.useState('');
    const [titleTouched, setTitleTouched ] = React.useState(false);
    const [authorTouched, setAuthorTouched ] = React.useState(false);
    const [pagesTouched, setPagesTouched ] = React.useState(false);
    const formCreateBookRef = useRef(null);
    const { handleCreateNewBook, isFetchingCreateNewBook } = React.useContext(Context);
    const navigate = useNavigate();

    useEffect(() => {
        setValidated(!!title && !!author && !!pages);
    }, [title, author, pages]);

    const searchBook = useRef(_.debounce((searchValue) => {
        if (!searchValue?.trim()) {
            setBookData([]);
            return;
        }
        axios.get('https://www.googleapis.com/books/v1/volumes?q=intitle:' + searchValue + '&maxResults=10')
            .then(res => setBookData(res.data.items))
            .catch(err => console.log(err))
    }, 1000)).current;

    useEffect(() => {
        return () => {
            searchBook.cancel();
        }
    }, [searchBook]);

    const notFoundMessage = () => {
            return (
                <>
                    <p className='notFoundMessage'>Puxa vida, não encontramos seu livro! Bora cadastrar?</p>
                    <Button className='addBook' onClick={() => {close(false); setCreateNewBookModal(true)}}>ADICIONAR LIVRO</Button>
                </>
            )
    }

    const openBookInformation = (selectedBook) => {
        navigate('/book', {state: selectedBook})
        close();
    }

    const booksFound = () => { 
        return (
            <>
            {bookData ? bookData.map((item, index) => {
                return (
                    <ListGroup as="ul" key={index}>
                        <ListGroup.Item onClick={() => openBookInformation(item)} as="li" key={index} type="none" >{item.volumeInfo.title}</ListGroup.Item>
                    </ListGroup>
                )
                }) : notFoundMessage()}
            </>
        )
    }; 

    const close = () => {
        setSearchModalShow(false);
        setBookData([]);
        setSearch("");
    }

    const handleSubmit = (event) => {    
        if (!formCreateBookRef.current.checkValidity()) {
            setValidated(true);
            return;
        }
        handleCreateNewBook(title, author, pages, publisher, description, image)
        setCreateNewBookModal(false)
        setValidated(false);
    };

    return (
        <>
            <div className='menu'>
                <ButtonGroup size='lg'>
                    <Button variant="secondary" onClick={() => navigate('/home')}>
                        <img src={estante} alt='estante' />
                    </Button>
                    <Button variant="secondary" onClick={() => setSearchModalShow(true)}>
                        <img src={buscar} alt='buscar' />
                    </Button>
                    <Button variant="secondary" onClick={() => navigate("/reminder")}>
                        <img src={lembrete} alt='lembrete' />
                    </Button>
                    <Button variant="secondary" onClick={() => navigate("/profile")}>
                        <img src={perfil} alt='perfil' />
                    </Button>
                </ButtonGroup>
                <ModalElement
                    show={searchModalShow}
                    onHide={() => close(false)}
                    size='lg'
                >
                    <h2 className='buscar'>Buscar</h2>
                    <Form className="d-flex">
                        <Form.Control
                            type="search"
                            placeholder="Buscar Livro"
                            className="me-2"
                            aria-label="Buscar Livro"
                            size='sm'
                            value={search}
                            onChange={e => {
                                setSearch(e.target.value);
                                searchBook(e.target.value);
                            }}
                        />
                        <Button variant="outline-success" onClick={() => searchBook()}>Pesquisar</Button>
                    </Form>
                    {booksFound()}
                </ModalElement>

                <ModalElement
                    show={createNewBookModal}
                    size='lg'
                    onHide={() => {
                        setCreateNewBookModal(false)
                        setValidated(false);
                    }}       
                >
                    <h2 className='criar-conta-text'>Cadastrar Livro</h2>
                    <Form ref={formCreateBookRef} validated={validated} id="form newBook">

                        <Form.Group className="mb-3" controlId="formBasicTitle">
                            <Form.Label>Título</Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control required onTouchStart={() => setTitleTouched(true)} onChange={(e) => setTitle(e.target.value)} type="text" isInvalid={titleTouched && !title}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher o título do livro.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicAuthor">
                            <Form.Label>Autor</Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control required onTouchStart={() => setAuthorTouched(true)} onChange={(e) => setAuthor(e.target.value)} type="text" isInvalid={authorTouched && !author}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher o autor do livro.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPages">
                            <Form.Label>Total de Páginas</Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control required onTouchStart={() => setPagesTouched(true)} onChange={(e) => setPages(e.target.value)} type="number" isInvalid={pagesTouched && !pages}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher o total de páginas do livro.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPublisher">
                            <Form.Label>Editora</Form.Label>
                            <InputGroup>
                                <Form.Control onChange={(e) => setPublisher(e.target.value)} type="text"/>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicDescription">
                            <Form.Label>Breve Descrição</Form.Label>
                            <Form.Control as="textarea" rows={3} onChange={(e) => setDescription(e.target.value)}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicImage">
                            <Form.Label>Imagem da capa</Form.Label>
                            <InputGroup>
                                <Form.Control onChange={(e) => setImage(e.target.value)} type="url" placeholder="Cole o link de uma url com a imagem"/>
                            </InputGroup>
                        </Form.Group>

                        <Button className='button' onClick={(e) => handleSubmit(e)} variant="primary" type="button">
                            {isFetchingCreateNewBook? <Load /> : 'CRIAR'}
                        </Button>
                        {/* {createError.isError && <ErrorModal text={createError.message} show={true}/>} */}
                    </Form>
                </ModalElement>
            </div>
        </>
    );
}

export default Menu